import contactSingleMessageModalCreator
    from '../../../../modules/messages/helpers/contact-single-message-modal-creator';

angular
    .module('festzelt-os.contacts')
    .factory('emailContact', [
        '$injector',
        ($injector) => {
            return {
                key: 'email-contact',
                title: 'Send Email',
                icon: 'envelope',
                order: 30,
                level: 'highlight',
                action(contact) {
                    contactSingleMessageModalCreator($injector, contact);
                }
            }
        }
    ]);



// WEBPACK FOOTER //
// ./src/app/pages/contacts/workflows/detailed-view/email-contact.js